import { render, staticRenderFns } from "./DerivationContract.vue?vue&type=template&id=27089ee4&"
import script from "./DerivationContract.vue?vue&type=script&lang=ts&"
export * from "./DerivationContract.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports